

export default function TabsContent(props){
    return(
        <ul className="tab-content">
            {props.children}
        </ul>
    )
}